import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsRequestsSelector = createSelector(
    careerAndSeasonStatsSelector,
    (careerAndSeasonStats) => careerAndSeasonStats.requests
);
